var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgSockets3Phase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.36,60.17A28.17,28.17,0,1,1,60.54,32,28.2,28.2,0,0,1,32.36,60.17Z",
    fill: "none",
    stroke: "#4f4e4f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.36,
    cy: 32,
    r: 26.17,
    fill: "none",
    stroke: "#4f4e4f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32.28,
    cy: 16.2,
    r: 3.13,
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.21,
    cy: 46.85,
    r: 3.13,
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.36,
    cy: 31.52,
    r: 3.13,
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.69,
    cy: 31.52,
    r: 3.13,
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.03,
    cy: 31.52,
    r: 3.13,
    fill: "#4f4e4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.3,58.17H26.42V54.58l1.94.36a21.86,21.86,0,0,0,8.26,0l1.68-.33Z",
    fill: "#4f4e4f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSockets3Phase);
export default __webpack_public_path__ + "static/media/img_sockets_3_phase.98bee17a616bae5eac6d7db1175519e8.svg";
export { ForwardRef as ReactComponent };